import React, { useEffect } from 'react';
import { Afp } from '../../../../app/models/Afp';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { Currency } from '../../../../app/models/Currency';
import { ForeignExchanges } from '../../../../app/models/ForeignExchange';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';

type Props = {
    foreignExchangesDataForm: ForeignExchanges;
    setforeignExchangesDataForm: (foreignExchanges: ForeignExchanges) => void;
    currencies: Currency[];
    errorFields?: any;
    manually?: boolean
};

const ForeignExchangeForm = ({ 
    foreignExchangesDataForm, 
    setforeignExchangesDataForm, 
    currencies, 
    errorFields,
    manually=false
}: Props) => {

    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setforeignExchangesDataForm({ ...foreignExchangesDataForm, [name]: value });
    };

    
    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        const obj = { [name]: value };

        setforeignExchangesDataForm({ ...foreignExchangesDataForm, ...obj });
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Moneda</label>
                <div className="col-md-9">
                    <SelectTwo
                        name="currency_id"
                        id="currency_id"
                        inputValue={foreignExchangesDataForm.currency_id}
                        options={SelectTwoMapperOptions(currencies, 'id', ['name'])}
                        hasError={fieldHasError('currency_id') !== ''}
                        onChange={(value: any) => handleChangeSelectTwo('currency_id', value.value)}
                        placeholder={'Seleccione Divisa'}
                        onFocus={() => onFocusRemove('currency_id')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('currency_id')}
                    </div>
                </div>

                <label className="col-md-3 col-form-label">Fecha de cambio</label>
                <div className="col-md-9">
                    <input
                        name="exchange_date"
                        id="exchange_date"
                        type="date"
                        className={`form-control ${fieldHasError('exchange_date')}`}
                        value={foreignExchangesDataForm.exchange_date}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('exchange_date')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('exchange_date')}
                    </div>
                </div>

                {
                    manually && (
                        <>
                            <label className="col-md-3 col-form-label">Valor</label>
                            <div className="col-md-9">
                                <input
                                    name="value"
                                    id="value"
                                    type="number"
                                    className={`form-control ${fieldHasError('value')}`}
                                    value={foreignExchangesDataForm.value}
                                    onChange={handleChange}
                                    onFocus={() => onFocusRemove('value')}
                                />
                                <div className="invalid-feedback" style={{ display: 'flex' }}>
                                    {fieldErrorMessage('value')}
                                </div>
                            </div>
                        </>
                    )
                }

            </div>
        </>
    );
};

export default ForeignExchangeForm;
